import { gql } from "@apollo/client";

export const GET_BUILT_IN_INTEGRATION = gql`
  query GetBuiltInIntegration {
    providers
    githubIntegration {
      vcsChecks
      useGitCheckout
    }
  }
`;
